import { DataStringComponent } from "./data-string-component.js";

export class DataTextareaComponent extends DataStringComponent {
    static webComponentName: string = "data-textarea";
    protected _templateId: string = "data-textarea-template";
    protected inputType: string = "textarea"; 
    constructor() {
        super();
    }
    
    addDataForTemplate(): Record<string, any> {
        const baseData = super.addDataForTemplate();
        
        // Extract rows attribute from the component, default to 3
        let rows = "3" 
        if(this.dataSlotElement) {
            rows = this.dataSlotElement.getAttribute('rows') || '3';
        }
        return {
            ...baseData,
            rows: parseInt(rows, 10)
        };
    }
}